import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

export const SectionContainer = styled(Box)`
  height: 100%;
  position: relative;
  display: flex;
  align-items: flex-end;
  ${themeMediaQuery('below_sm')} {
    height: 797px;
    max-height: 1000px;
    overflow: hidden;
  }
`;

export const SectionPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 100%;
  height: 100%;
  bottom: 0px;
  ${themeMediaQuery('below_sm')} {
    object-fit: cover;
    object-position: 72% 50%;
  }
`;

export const StyledEcoText = styled(TextPairing)`
  width: 100%;
  .text-pairing-title {
    max-width: 320px;
  }
  .text-pairing-body {
    max-width: 400px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 700px;
    }
    .text-pairing-body {
      max-width: 500px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 325px;
    }
    .text-pairing-body {
      max-width: 387px;
    }
    .text-pairing-eyebrow {
      max-width: 240px;
    }
  }
`;

export const StyledColumns = styled(Columns)`
  margin-top: ${themeSpace(10)};
`;

export const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-image: linear-gradient(rgba(24, 42, 0, 0.8), rgba(24, 42, 0, 0));
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 60px;
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(9)};
    padding-bottom: ${themeSpace(9)};
  }
`;

export const StyledLazyLoadWrapper = styled(LazyLoadWrapper)`
  top: 0px;
  position: absolute;
`;
